import { useTranslation } from 'react-i18next';
import { PublicPageLayout } from '../../layout/PublicPageLayout';

/**
 * Pagina pubblica Terms of Service. Stesso pattern di PrivacyPolicyPage:
 * 10 sezioni numerate + heading + lastUpdated + 2 intro + contact email.
 *
 * Route: `/terms-of-service` (pubblica, no auth).
 */
export function TermsOfServicePage() {
  const { t } = useTranslation();

  return (
    <PublicPageLayout selfPage="terms">
      <h1>{t('terms.heading')}</h1>
      <p>
        <em>{t('terms.lastUpdated')}</em>
      </p>
      <p>{t('terms.intro1')}</p>
      <p>{t('terms.intro2')}</p>

      <h2>{t('terms.section1.title')}</h2>
      <p>{t('terms.section1.content1')}</p>
      <p>{t('terms.section1.content2')}</p>

      <h2>{t('terms.section2.title')}</h2>
      <p>{t('terms.section2.intro1')}</p>
      <p>{t('terms.section2.intro2')}</p>
      <ul>
        <li>{t('terms.section2.item1')}</li>
        <li>{t('terms.section2.item2')}</li>
        <li>{t('terms.section2.item3')}</li>
        <li>{t('terms.section2.item4')}</li>
      </ul>
      <p>{t('terms.section2.outro')}</p>

      <h2>{t('terms.section3.title')}</h2>
      <p>{t('terms.section3.intro')}</p>
      <ul>
        <li>{t('terms.section3.item1')}</li>
        <li>{t('terms.section3.item2')}</li>
        <li>{t('terms.section3.item3')}</li>
      </ul>

      <h2>{t('terms.section4.title')}</h2>
      <p>{t('terms.section4.content1')}</p>
      <p>{t('terms.section4.content2')}</p>
      <p>{t('terms.section4.content3')}</p>

      <h2>{t('terms.section5.title')}</h2>
      <p>{t('terms.section5.content1')}</p>
      <p>{t('terms.section5.content2')}</p>

      <h2>{t('terms.section6.title')}</h2>
      <p>{t('terms.section6.content1')}</p>
      <p>{t('terms.section6.content2')}</p>

      <h2>{t('terms.section7.title')}</h2>
      <p>{t('terms.section7.content1')}</p>
      <p>{t('terms.section7.content2')}</p>

      <h2>{t('terms.section8.title')}</h2>
      <p>{t('terms.section8.content1')}</p>
      <p>{t('terms.section8.content2')}</p>

      <h2>{t('terms.section9.title')}</h2>
      <p>{t('terms.section9.content1')}</p>
      <p>{t('terms.section9.content2')}</p>

      <h2>{t('terms.section10.title')}</h2>
      <p>{t('terms.section10.content')}</p>
      <p>
        <a href="mailto:support@d-vel.com">{t('terms.section10.email')}</a>
      </p>
    </PublicPageLayout>
  );
}
